import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

export const SliderRangeCandidate = ({
    name,
    sliderRangeMin,
    sliderRangeMax,
    sliderInitialUserValue,
    register,
    showSliderValueDetails,
    sliderRangeMinDetail,
    sliderRangeMaxDetail,
    sliderInitialUserValueDetail,
}) => {
    const [sliderRangeValue, setSliderRangeValue] = useState(sliderInitialUserValue);
    const [positionLeft, setPositionLeft] = useState('');
    const rangeRef = useRef(null);

    useEffect(() => {
        setSliderRangeValue(sliderInitialUserValue);
        setPositionLeft(
            convertRangeToPositionLeft(((sliderRangeValue - sliderRangeMin) / (sliderRangeMax - sliderRangeMin)) * 100)
        );
        if (rangeRef.current) {
            rangeRef.current.addEventListener('wheel', handleWheel);
        }

        return () => {
            if (rangeRef.current) {
                rangeRef.current.removeEventListener('wheel', handleWheel);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const element = document.getElementById(name);
        setColorRange(element, sliderRangeValue);
        setPositionLeft(
            convertRangeToPositionLeft(((sliderRangeValue - sliderRangeMin) / (sliderRangeMax - sliderRangeMin)) * 100)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sliderRangeValue]);

    const handleWheel = (event) => {
        if (rangeRef.current) {
            event.preventDefault();
            event.stopPropagation();

            const currentValue = Number(rangeRef.current.value);
            const newValue = event.deltaY > 0 ? currentValue - 1 : currentValue + 1;
            const clampedValue = Number(Math.min(Math.max(newValue, sliderRangeMin), sliderRangeMax).toFixed());

            setSliderRangeValue(clampedValue);
        }
    };

    const onChangeValue = (value) => {
        setSliderRangeValue(value);
        setPositionLeft(
            convertRangeToPositionLeft(((value - sliderRangeMin) / (sliderRangeMax - sliderRangeMin)) * 100)
        );
    };

    const setColorRange = (element, currentRange) => {
        const percentage = ((currentRange - sliderRangeMin) / (sliderRangeMax - sliderRangeMin)) * 100;
        const percentageAfterConvert = convertRangeToPositionLeft(percentage);

        element.style.setProperty('--value-percentage', `${percentageAfterConvert}`);
        element.style.background = `linear-gradient(to right, #004c97 0%, #004c97 var(--value-percentage, ${percentageAfterConvert}), #ddd var(--value-percentage, ${percentageAfterConvert}), #ddd 100%)`;
    };

    const handleMouseDown = () => {
        document.onmousemove = handleMouseMove;
        document.onmouseup = handleMouseUp;
    };

    const handleTouch = () => {
        document.ontouchmove = handleTouchMove;
        document.ontouchend = handleTouchEnd;
    };

    const handleTouchEnd = () => {
        document.ontouchmove = null;
        document.ontouchend = null;
    };

    const handleTouchMove = (e) => {
        const rect = rangeRef.current.getBoundingClientRect();

        const touch = e.touches[0];
        const clientX = touch.clientX < rect.left ? rect.left : touch.clientX > rect.right ? rect.right : touch.clientX;

        const offsetX = clientX - rect.left;
        const percent = Number(((offsetX / rect.width) * 100).toFixed());
        const relativeValue = Number(((percent * (sliderRangeMax - sliderRangeMin)) / 100).toFixed()) + sliderRangeMin;
        setSliderRangeValue(relativeValue);
    };

    const handleMouseMove = (e) => {
        const rect = rangeRef.current.getBoundingClientRect();

        const clientX = e.clientX < rect.left ? rect.left : e.clientX > rect.right ? rect.right : e.clientX;

        const offsetX = clientX - rect.left;
        const percent = Number(((offsetX / rect.width) * 100).toFixed());
        const relativeValue = Number(((percent * (sliderRangeMax - sliderRangeMin)) / 100).toFixed()) + sliderRangeMin;
        setSliderRangeValue(relativeValue);
    };

    const handleMouseUp = () => {
        document.onmousemove = null;
        document.onmouseup = null;
    };

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    };

    const convertRangeToPositionLeft = (percentage) => {
        const percent = Math.floor(percentage / 10);
        switch (percent) {
            case 0:
                return `calc(${percentage}% + 0.5rem)`;
            case 1:
                return `calc(${percentage}% + 0.4rem)`;
            case 2:
                return `calc(${percentage}% + 0.3rem)`;
            case 3:
                return `calc(${percentage}% + 0.2rem)`;
            case 4:
                return `calc(${percentage}% + 0.1rem)`;
            case 5:
                return `${percentage}%`;
            case 6:
                return `calc(${percentage}% - 0.1rem)`;
            case 7:
                return `calc(${percentage}% - 0.2rem)`;
            case 8:
                return `calc(${percentage}% - 0.3rem)`;
            case 9:
                return `calc(${percentage}% - 0.4rem)`;
            case 10:
                return `calc(${percentage}% - 0.5rem)`;
            default:
                break;
        }
    };

    const convertTranslateX = (percentage) => {
        const percent = Math.floor(percentage / 10);
        switch (percent) {
            case 0:
                return 'translateX(-25%)';
            case 1:
                return 'translateX(calc(-25% - 0.1rem))';
            case 2:
                return 'translateX(calc(-25% - 0.2rem))';
            case 3:
                return 'translateX(calc(-25% - 0.3rem))';
            case 4:
                return 'translateX(calc(-25% - 0.4rem))';
            case 5:
                return 'translateX(calc(-25% - 0.5rem))';
            case 6:
                return 'translateX(calc(-25% - 0.6rem))';
            case 7:
                return 'translateX(calc(-25% - 0.7rem))';
            case 8:
                return 'translateX(calc(-25% - 0.8rem))';
            case 9:
                return 'translateX(calc(-25% - 0.9rem))';
            case 10:
                return 'translateX(calc(-25% - 1rem))';
            default:
                break;
        }
    };

    return (
        <div className='flex flex-row items-center'>
            <div className='block mt-12 mr-2 w-1/12 text-center relative'>
                <span className={`${showSliderValueDetails ? 'visible' : 'invisible'}`}><strong>{sliderRangeMin}</strong></span>
                <span className='absolute top-[30px] w-[50px] -translate-x-1/2 left-1/2 break-all'>
                    {sliderRangeMinDetail}
                </span>
            </div>
            <div className='flex flex-col w-5/6 relative py-2 mt-12'>
                <input
                    className='accent-lg-blue slider-range'
                    id={name}
                    min={sliderRangeMin}
                    max={sliderRangeMax}
                    type='range'
                    value={sliderRangeValue}
                    {...register}
                    ref={rangeRef}
                    onChange={(event) => onChangeValue(event.target.value)}
                    onKeyDown={(event) => handleKeyDown(event)}
                />
                <span
                    className={classNames(
                        'absolute top-[35.5px] break-all text-center',
                        {'min-w-[20px]' : sliderInitialUserValueDetail?.length <= 2},
                        {'w-[50px]' : sliderInitialUserValueDetail?.length > 2},
                    )}
                    style={{
                        left: convertRangeToPositionLeft((sliderInitialUserValue - sliderRangeMin) / (sliderRangeMax - sliderRangeMin) * 100),
                        transform: convertTranslateX((sliderInitialUserValue - sliderRangeMin) / (sliderRangeMax - sliderRangeMin) * 100),
                    }}>
                    {sliderInitialUserValueDetail}
                </span>
                <div className='max-w-full px-2 box-border relative'>
                    <div className='w-full relative'>
                        <span
                            className='flex absolute box-border transition-shadow items-center rounded-[50%] justify-center bg-lg-blue top-[-65px]'
                            role='slider'
                            style={{
                                left: positionLeft,
                            }}
                            data-index='0'>
                            <label
                                onMouseDown={() => handleMouseDown()}
                                onTouchStart={() => handleTouch()}
                                htmlFor={name}
                                id='thumb-label'
                                className='z-[1] absolute text-xs scale-[1] transition-shadow tracking-[.01071em] origin-[bottom_center] cursor-pointer select-none'>
                                <span className='w-10 h-10 flex rotate-[-45deg] items-center rounded-[50%_50%_50%_0] justify-center bg-lg-blue'>
                                    <span className='text-white rotate-[45deg]'>
                                        <strong className={`${showSliderValueDetails ? 'visible' : 'invisible'}`}>{sliderRangeValue}</strong>
                                    </span>
                                </span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className='block mt-12 ml-2 w-1/12 text-center relative'>
                <span className={`${showSliderValueDetails ? 'visible' : 'invisible'}`}><strong>{sliderRangeMax}</strong></span>
                <span className='absolute top-[30px] w-[50px] -translate-x-1/2 left-1/2 break-all'>
                    {sliderRangeMaxDetail}
                </span>
            </div>
        </div>
    );
};